module.exports = function() {
  return new Worker(__webpack_public_path__ + "55ca722f2155ac7dba61.worker.js");
};